import { cn } from "@/lib/utils";

/** BitPays logomark — a rounded gradient tile with a lightning glyph. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-xl bp-gradient text-white shadow-soft",
        className
      )}
    >
      <svg width="60%" height="60%" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z" fill="currentColor" />
      </svg>
    </div>
  );
}

/** BitPays wordmark. `on="dark"` for use on the dark sidebar. */
export function Wordmark({ on = "light", className }: { on?: "light" | "dark"; className?: string }) {
  return (
    <span className={cn("text-lg font-extrabold tracking-tight", className)}>
      <span className={on === "dark" ? "text-white" : "text-foreground"}>Bit</span>
      <span className="bp-gradient-text">Pays</span>
    </span>
  );
}

export function BrandRow({ on = "light" }: { on?: "light" | "dark" }) {
  return (
    <div className="flex items-center gap-2.5">
      <LogoMark className="h-8 w-8" />
      <Wordmark on={on} />
    </div>
  );
}
